(() => {
  setTimeout(() => {
    const $heading = document.querySelector('.section-for-dogs #order-now-section .mainHeading');
    const cardsContainer = document.querySelector('.section-for-dogs #order-now-section .order-nowMainSection');
    const mainItem = document.querySelectorAll('.section-for-dogs .order-nowItem')[0];
    const mainShippingBanner = mainItem.querySelector('.section-for-dogs .BrX1sr73');
    const mainPaymentBanner = mainItem.querySelector('.section-for-dogs .BrX1sr73 + img');
  
    console.log({ $heading, mainShippingBanner, mainPaymentBanner });
    console.log("Mario");
  
    const shippingClone = mainShippingBanner?.cloneNode(true);
    const paymentClone = mainPaymentBanner?.cloneNode(true);
  
    if (shippingClone && paymentClone) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('banners-wrapper');
  
      const shippingContainer = document.createElement('div');
      shippingContainer.classList.add('shipping-banner-wrapper');
      shippingContainer.appendChild(shippingClone);
  
      const paymentContainer = document.createElement('div');
      paymentContainer.classList.add('payment-banner-wrapper');
  
      const paymentTitle = document.createElement('p');
      paymentTitle.innerText = 'Pay securely with:';
   
  
      paymentContainer.appendChild(paymentTitle);
      paymentContainer.appendChild(paymentClone);
  
      wrapper.appendChild(shippingContainer);
      wrapper.appendChild(paymentContainer);
  
      cardsContainer?.insertAdjacentElement('afterend', wrapper);
    }
        let selectors = [
    '.total-to-pay .compare .money',
    '.total-to-pay .saving .money',
    '.per-kit .money'
  ];

  selectors.forEach(selector => {
    let $elements = document.querySelectorAll(selector);
    if (!$elements.length) return;

    $elements.forEach($element => {
      const text = $element.innerText.trim();
      const parts = text.split(/\s+/);
      const priceOnly = parts[0] || '';
      const currencyOnly = parts[1] || '';
      const path = window.location.pathname || '';

      $element.innerHTML = '';

      if (currencyOnly && (path.includes('/en-ca/') || path.includes('/en-au/'))) {
        $element.innerHTML = `<span data-price>${priceOnly}</span> <span data-currency>${currencyOnly}</span>`;
      } else {
        $element.innerHTML = `<span data-price>${priceOnly}</span>`;
      }
    });
  });
  }, 300);
})();